<template>
	<div>
		<!-- 分页 -->
		<div class="workbench_paging clearfix">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
			 :page-sizes="[10,20,50,100]" :page-size="pageSize" :total="help" layout="total, sizes, prev, pager, next, jumper">
			</el-pagination>
		</div>
		<!-- 分页 -->
	</div>
</template>

<script>
	export default{
		props:['help','currentPage','pageSize'],
		data(){
			return{
				
			}
		},
		mounted() {
			
		},
		methods:{
			// 每页显示条数 10，20，50，100
			handleSizeChange(val) {
				this.$emit('handleSizeChange',val)
			},
			//当前页的index
			handleCurrentChange(val) {
				this.$emit('handleCurrentChange',val)
			}
		}
	}
</script>

<style>
	
</style>
